import "./Stats.scss";
import React from "react";
import {Link} from "react-router-dom";
import classNames from "classnames";


const Stat = ({
        onClick,
        isLink,
        className,
        children,
        ...props
    })=>{

    const Tag = isLink ? Link : 'div';

    return (
        <Tag {...props} className={classNames('v3-stats-row', (isLink || onClick) && "link", className)} >
            {children}
        </Tag>
    );
}

const Stats = ({data = []})=>{

    return (
        <div className="v3-stats">
            {data.map(item =>(
                <Stat key={item.label} isLink={item.isLink} {...item} >
                    {item.count}
                    <div className="v3-stats-row-title">{item.label}</div>
                </Stat>
            ))}
        </div>
    );
}

export default Stats;